module.exports = __webpack_public_path__ + "static/img/019.a7bcf9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/019.png
// module id = Z4wV
// module chunks = 0